export function formatMoney(cents, format = 'amount') {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  let value = '';

  const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
    if (isNaN(number) || number === null) return '0';

    number = (number / 100.0).toFixed(precision);
    const parts = number.split('.');
    const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    const cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  switch (format) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, '\'', '.');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return value;
}

export function stripHtmlTags(input) {
  const BR_PLACEHOLDER = '__BR__';
  const P_OPEN_PLACEHOLDER = '__P_OPEN__';
  const P_CLOSE_PLACEHOLDER = '__P_CLOSE__';
  const S_OPEN_PLACEHOLDER = '__S_OPEN__';
  const S_CLOSE_PLACEHOLDER = '__S_CLOSE__';

  let html = input;

  html = html.replace(/<br\s*\/?>/gi, BR_PLACEHOLDER);

  html = html.replace(/<p[^>]*?>/gi, P_OPEN_PLACEHOLDER);
  html = html.replace(/<\/p>/gi, P_CLOSE_PLACEHOLDER);
  html = html.replace(/<strong[^>]*?>/gi, S_OPEN_PLACEHOLDER);
  html = html.replace(/<\/strong>/gi, S_CLOSE_PLACEHOLDER);

  html = html.replace(/<\/?[^>]+>/gi, '');

  return html
    .replaceAll(P_OPEN_PLACEHOLDER, '<p>')
    .replaceAll(P_CLOSE_PLACEHOLDER, '</p>')
    .replaceAll(S_OPEN_PLACEHOLDER, '<strong>')
    .replaceAll(S_CLOSE_PLACEHOLDER, '</strong>')
    .replaceAll(BR_PLACEHOLDER, '<br>');
}
